import {Sort, UrlParameter} from "../../../shared/utils/url.builder";
import {Observable} from "rxjs";
import {EntityCollectionServiceBase} from "@ngrx/data";
import {map} from "rxjs/operators";
import {HttpModelConverter} from "../../../modules/core/converter/httpModel.converter";
import {PaginatedEntityCollectionReadOnlyService} from "../../../modules/core/service/paginatedEntityCollectionReadOnlyService";
import {DefaultDataservice} from "../dataservice/default.dataservice";

export class SearchService<T, C extends HttpModelConverter<T>> extends PaginatedEntityCollectionReadOnlyService<T, C>{

    constructor(serviceName: string,
                entityCollectionServiceBase: EntityCollectionServiceBase<T>,
                dataService: DefaultDataservice<T>, converter: C, pageSize: number, sort?: Sort, parameters?: UrlParameter[]) {
        super(serviceName, entityCollectionServiceBase, dataService, converter, pageSize, sort, parameters);
    }
    getByKey(key: any): Observable<T> {
        return this.entityCollectionServiceBase.getByKey(key).pipe(map(value => this.converter.convert(value)));
    }
}